import { OurAggregated } from '@/src/dataRequest/ourAggregated.js';
import { skillsManTemplate } from '@/Template/skills_man_template/skills_man_template.js';

export let vehicleOperation_template = {
  SUMM_AREA_ID: 'section-reports',
  Report: {},
  isConsoleLog: false, 
  ourAggregated: new OurAggregated(skillsManTemplate), 

  onclick: function (event) {
    this.submit();
  },

  submit: function (form_desc, callback) {
    let button = document.getElementById(
      'vehicleOperation-template-setting-window-get-template-button',
    );
    let targetSpan = getNeighborByClass_helper(button, 'target-show-span');

    infoShowText_helper(
      targetSpan,
      'Обсчет данных для получения отчета',
      this.SUMM_AREA_ID,
    );

    vehicleOperation_template.Report.begin = +form_desc['beginTime'];
    vehicleOperation_template.Report.end = +form_desc['endTime'];

    vehicleOperation_template.getReportSettings();

    vehicleOperation_template.requestData(form_desc, callback);
  },

  requestData(form_desc, callback) {
    // test                                                                                                                                                                                              │
    // form_desc.beginTime = 1757959200000;
    // form_desc.endTime = 1758045600000;
    // form_desc.objects = ['51937', '52959'];
    // console.log('form_desc', form_desc);
    
    vehicleOperation_template.ourAggregated.callOurAggregated({
      option: 1,
      templateName: 'vehicle_operation',
      form_desc,
      areaId: 'section-reports',
      type: vehicleOperation_template.Report.groupBy,
      callback,
    });
  },

  getReportSettings: function () {
    this.Report.groupBy = document.getElementById('groupBy').value;
  },
};